module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-2021-2.04e88b26.jpg";